<template>
    <div class="container container--catalog">

        <Loader v-if="!isReady"></Loader>

        <List v-else class="list--products"
            :filtering="this"
            :itemNameSingular="'article'"
            :itemNamePlural="'articles'">

            <template v-slot:actions>
                    
                <Button 
                    class=".native"
                    :disabled="!hasContent"
                    :loading="processingXlsx"
                    @click.native="downloadXlsx">
                    <span class="fa fa-file-excel-o"></span>
                    Télécharger
                </Button>
            
            </template>

            <template v-slot:filters>
                <ListFilter class="filter--main">
                    <input v-model="filters.query"
                        type="text"
                        placeholder="Rechercher dans mes articles favoris"/>
                </ListFilter>             
            </template>            
            
            <template v-slot:checkboxActions>
                <button class="woocommerce-button button alt"
                    :disabled="processing || !itemSelected"
                    v-on:click="buy()">
                    <span class="fa fa-shopping-cart"></span>
                    Ajouter au panier
                </button>
                <button class="woocommerce-button button"
                    :disabled="!itemSelected"
                    v-on:click="removeFavorite()">
                    Retirer
                </button>
            </template>

            <template v-slot:heading>
                <div class="cell cell--cb">
                    <TogglerAll />
                </div>
                <div class="cell cell--ref">Réf.</div>
                <div class="cell cell--main">Produit</div>
                <div class="cell">U.V.</div>
                <div class="cell cell--price">Prix HT</div>
                <div class="cell cell--actions">Actions</div> 
            </template>

            <ul class="list__content favorite-list" v-if="hasContent">

                <li class="list__content__item"
                    v-for="item in items"
                    :key="item.id">
                    
                    <Article       
                        v-model="selectedItems"
                        :variation="item" />

                </li>

            </ul>

            <div class="container_list container_list--no-result" v-else>
                <h1 class="woocommerce-order-details__title" v-show="!isFiltering">Aucun article favoris</h1>
            </div>  

            <div class="list__next" v-if="hasMore">
                <Loader v-if="isLoadingMore"></Loader>
                <button
                    class="button"
                    type="button"
                    @click="next"
                    v-else>Voir les articles favoris suivants</button>
            </div>

        </List>

    </div>
</template>

<script>

import Article from '@/components/article/Article.vue'
import Button from '@/components/button/Button.vue'
import List, { ListFilter, TogglerAll }  from '@/components/list/List.vue'
import Loader from '@/components/loader/Loader.vue'

import api from '@/api/proxyWeb/me'

import cart from '@/containers/cart.vue'
import filtering from "@/containers/filtering";
import selectAll from '@/containers/selectAll.vue'

export default {

    name: 'FavoriteList',

    data: function() {
        return {
            filters: {
                query: '',
            },
            processingXlsx: false
        }
    },

    methods: {

        buy() {

            let articles = this.selectedItems.map(variation => {
                    return {
                        'id': variation.article.id,
                        'quantity': 1,
                        'variationId': variation.id
                    }
                })

            this.addToCart(articles);
        },
        
        downloadXlsx() {
            this.processingXlsx = true
            api.getFavoritesXlsx(this.params)
                .then(() => { this.$notify.success('Téléchargement en cours...') })
                .finally(() => { this.processingXlsx = false } )
        },   

        async removeFavorite() {

            try {
                const promises = this.selectedItems.map(async (variation) => {
                    await api.deleteFavorite(variation.postId)
                    this.$notify.success( 'Articles ' + variation.article.title + ' retiré des favoris' )
                })
                await Promise.all(promises)
                await this.init()
                this.selectedItems.splice(0)
            }
            catch(error) {
                this.$errorPage(error.reason)
            }
        }
    },
  
    created () {
        this.useFilter(api);
    },

    watch: {

        items: function() {            
            this.selectableItems = []
            this.items.forEach(item => {
                if ( item.article.isAvailable && item.article.isActive ) {
                    this.selectableItems.push(item)
                }
            })
        }        
    },    
    components: {
        Article,
        Button,
        List,
        ListFilter,
        Loader,
        TogglerAll
    },

    mixins: [ cart, filtering, selectAll ]
}
</script>

<style scoped>
.cell.cell--actions {
    min-width: 10rem;
}

</style>
